import { Currency } from '@uniswap/sdk-core'
import useCurrencyLogoURIs from 'lib/hooks/useCurrencyLogoURIs'
import React from 'react'
import styled from 'styled-components/macro'

import Logo from '../Logo'

const StyledLogo = styled(Logo)<{ size: string; native: string }>`
  width: ${({ size }) => size};
  height: ${({ size }) => size};
  //background: #ffffff;
  border-radius: 50%;
  // -mox-box-shadow: 0 0 1px ${({ native }) => (native === 'true' ? 'white' : 'black')};
  // -webkit-box-shadow: 0 0 1px ${({ native }) => (native === 'true' ? 'white' : 'black')};
  // box-shadow: 0 0 1px ${({ native }) => (native === 'true' ? 'white' : 'black')};
  border: 0px solid rgba(255, 255, 255, 0);
`

export default function CurrencyLogo({
  currency,
  size = '24px',
  style,
  ...rest
}: {
  currency?: Currency | null
  size?: string
  style?: React.CSSProperties
}) {
  const logoURIs = useCurrencyLogoURIs(currency)

  return (
    <StyledLogo
      size={size}
      native={(currency?.isNative ?? false).toString()}
      srcs={logoURIs}
      alt={`${currency?.symbol ?? 'token'} logo`}
      title={`${currency?.symbol ?? 'token'}`}
      style={style}
      {...rest}
    />
  )
}
